 // RingLayer.tsx
import React from 'react';
import { RING_RADII, RING_LABELS, RING_FILLS, RING_STROKES } from '../../types';
import { decaPtsStr } from '../../utils/geometry';

const LABEL_ANGLES = [90, 90, 90, 90, 90] as const;

interface RingLayerProps {
  scale?: number;
}

const RingLayer: React.FC<RingLayerProps> = ({ scale = 1 }) => (
  <g id="layer-rings">
    {[...RING_RADII].reverse().map((r, ri) => {
      const idx = RING_RADII.length - 1 - ri;
      const scaledRadius = r * Math.max(1, scale);
      const angle = (LABEL_ANGLES[idx] * Math.PI) / 180;
      const labelRadius = scaledRadius - 14;
      const lx = Math.cos(angle) * labelRadius;
      const ly = Math.sin(angle) * labelRadius;
      return (
        <g key={`${r}-${scale}`}>
          <polygon points={decaPtsStr(scaledRadius)} fill={RING_FILLS[idx]} />
          <polygon points={decaPtsStr(scaledRadius)} fill="none" stroke={RING_STROKES[idx]} strokeWidth={1.8} />
          <text
            x={lx} y={ly}
            fontFamily="'Caveat',cursive" fontSize={24}
            textAnchor="middle" dominantBaseline="auto"
            fill={RING_STROKES[idx]} 
            pointerEvents="none"
            style={{ userSelect: 'none' }}
          >
            {RING_LABELS[idx]}
          </text>
        </g>
      );
    })}
  </g>
);

export default RingLayer;
